/** @typedef {import('./ProviderSettings.svc')} Types */

export class ProviderSettings {
	constructor($http, API, $q) {
		'ngInject';
		this.q = $q;
		this.http = $http;
		this.path = `${API}/v1/setting`;
	}

	/** @param {Types.GetGlobalExpirationDateParams} params */
	getGlobalExpirationDate(params) {
		return this.http.get(`${this.path}/globalExpirationDateForConsultations`, params);
	}

	/** @param {Types.GetProviderSettingsParams} params */
	getProviderSettings(params, doCache = false) {
		return this.http.get(`${this.path}/providerSettings`, {params, cache: doCache});
	}

	/** @param {Types.PostUpdateGlobalExpirationParams} params */
	postUpdateGlobalExpiration(params) {
		return this.http.post(`${this.path}/updateConsultationExpirationIntervalInDays`, params);
	}

	/** @param {Types.PostUpdateProviderSettingParams} params */
	postUpdateProviderSetting(params) {
		return this.http.post(`${this.path}/updateProviderSetting`, params);
	}
}
//
let compMod = angular
	.module('mod.svc.ProviderSettingsSvc', [])
	.service('ProviderSettingsSvc', ProviderSettings);
export default (compMod = compMod.name);
